/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-2017
 * Existing validations for fields inside form
 */

const required = (value) => {
    if (value === null || value === undefined || value === '') {
        return false;
    }
    return true;
};

const onlyNumbers = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/^-?(0|[1-9]\d*)$/).test(value);
    }
    return true;
};

const moreThanZero = (value) => {
    if (value > 0) {
        return true;
    }
    return false;
};

const numberWithDecimals = (value) => {
  if (value !== null && value !== undefined && value !== '') {
      return new RegExp(/^\d+(\.\d{1,3})?$/).test(value);
  }
  return true;
};

const onlyMonetaryValues = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/^\$?[\d,]+(\.\d*)?$/).test(value);
    }
    return true;
};

const validationEmail = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm).test(value);
    }
    return true;
};
const validationMask = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/^$|^\d{4}-\d{7}$/).test(value);
    }
    return true;
};
const validationZipCode = (value) => {
    if (value != null) {
        if (value.length > 10) {
            return false;
        }
    }
    return true;
};

const validationPhone1 = (value) => {
    if (value != null) {
        if (value.length != 10) {
            return false;
        }
    }
    return true;
};

const validationInvoiceItem = (value) => {
    if (value != null) {
        if (value.length > 9) {
            return false;
        }
    }
    return true;
};

var ValueEmail1 = "";
const SaveEmail1Value = (value) => {
    ValueEmail1 = value;
    return true;
};

const ConfirmEmail = (value) => {
    if (value === ValueEmail1) {
        return true;
    }
    return false;
};

const packagesRules = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/^[A-Za-z0-9]* [a-zA-Z]*$/).test(value);
    }
    return true;
};

const percentajeValues = (value) => {
    if (value !== null && value !== undefined && value !== '') {
        return new RegExp(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(value);
    }
    return true;
};


const availableRules = {
    required,
    onlyNumbers,
    onlyMonetaryValues,
    validationZipCode,
    validationPhone1,
    packagesRules,
    validationEmail,
    percentajeValues,
    SaveEmail1Value,
    ConfirmEmail,
    validationMask,
    numberWithDecimals,
    validationInvoiceItem,
    moreThanZero
};

export const validateField = (rules, key, value) => {
    let errors = [];

    if (key in rules) {
        rules[key].forEach(fieldRule => {
            if (!availableRules[fieldRule.key](value)) {
                errors = [...errors, fieldRule.errorText];
            }
        });
    }

    return { [key]: errors };
};

export const validateForm = (form, rules) => {
    let errors = {};

    Object.keys(form).forEach(formKey => {
        errors = Object.assign({}, errors, validateField(rules, formKey, form[formKey]));
    });

    return errors;
};

/**
 * Builds an erros state
 * @param {obj} fields plane object with fields to validate
 */
export const buildErrorsState = (fields) => {
    return Object.assign(...fields.map(({ key }) => ({ [key]: [] })));
};

export const fieldIsRequired = (key, rules) => {
    if (key in rules) {
        return rules[key].find(r => r.key === 'required');
    }

    return false;
};

/**
 * Test if errors are empty
 * @param {obj} errors
 */
export const errorsEmpty = (errors) => {
    let propsWithErrors = 0;

    Object.keys(errors).forEach(key => {
        if (errors[key].length > 0) {
            propsWithErrors += 1;
        }
    });

    return propsWithErrors === 0;
};



// WEBPACK FOOTER //
// ./validations/index.js